import axios from "axios";
import { useContext } from "react";

import { destoryTokens } from "../../api/auth";
import { useRefreshUser } from "../../apiHooks/auth";
import DataContext from "../../context/dataContext";

const client = axios.create({
  baseURL: `${process.env.REACT_APP_HOSTNAME}/api`,
  headers: {
    "Accept-language": "ka",
  },
});

const AxiosInterceptor = ({ children }) => {
  const { setUserData, setAuth } = useContext(DataContext);
  const { refreshUser } = useRefreshUser();

  client.interceptors.request.use(
    (config) => {
      const token = window.localStorage.getItem("access-token");
      // eslint-disable-next-line no-param-reassign
      if (token && token !== "undefined")
        config.headers.Authorization = `Bearer ${token}`;
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  client.interceptors.response.use(
    async (config) => {
      if (config.config.url === "/login/" && config.status === 200) {
        // dispatch(openSuccess('თქვენ წარმატებით გაიარეთ ავტორიზაცია'));
      }
      return config;
    },
    async (error) => {
      if (error?.response?.status === 401) {
        if (error.response.config.url === "/jwt/token/refresh/") {
          destoryTokens();
          setUserData({});
          setAuth(false);
          
        }

        const refreshToken = window.localStorage.getItem("refresh-token");
        const accessToken = window.localStorage.getItem("access-token");

        if (
          refreshToken &&
          error.response.config.url !== "/jwt/token/refresh/"
        ) {
          await refreshUser({ refreshToken: refreshToken });
          return axios.request({
            ...error.response.config,
            data: error.config.data ? JSON.parse(error.config.data) : "",
          });
        }
        if (!accessToken || !refreshToken) return destoryTokens();
      }

      return Promise.reject(error);
    }
  );

  return children;
};

export default client;
export { AxiosInterceptor };
